import React, { useState, useRef } from 'react';
import './BibliaRespondeLanding.css';
import { FaStar, FaChevronRight } from 'react-icons/fa';

const BibliaRespondeLanding = () => {
  const [expandedFaq, setExpandedFaq] = useState(1);
  const cardsRef = useRef(null);

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  const getCardsScrollAmount = () => {
    const container = cardsRef.current;
    if (!container) return 0;
    const firstCard = container.querySelector('.feature-card');
    const style = window.getComputedStyle(container);
    const gapStr = style.gap || style.columnGap || '0px';
    const gap = gapStr.endsWith('px') ? parseFloat(gapStr) : 0;
    const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : container.clientWidth;
    return cardWidth + gap;
  };

  const handlePrevCards = () => {
    const container = cardsRef.current;
    if (!container) return;
    container.scrollBy({ left: -getCardsScrollAmount(), behavior: 'smooth' });
  };

  const handleNextCards = () => {
    const container = cardsRef.current;
    if (!container) return;
    container.scrollBy({ left: getCardsScrollAmount(), behavior: 'smooth' });
  };

  const handlePlansClick = () => {
    // Scroll para seção de pricing
    const pricingSection = document.querySelector('.pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSupportClick = () => {
    // Scroll para seção FAQ
    const faqSection = document.querySelector('.faq-section');
    if (faqSection) {
      faqSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLanguageClick = () => {
    // Placeholder para seleção de idioma
    console.log('Seleção de idioma clicada');
  };

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header">
        <div className="header-container">
          <div className="nav-left">
            <div className="logo">
              <img src="/LOGO.svg" alt="Bíblia Responde Logo" />
            </div>
            <nav className="nav-items">
              <div className="nav-item" onClick={handlePlansClick} role="button" tabIndex={0}>
                <span>Planos</span>
              </div>
              <div className="nav-item" onClick={handleSupportClick} role="button" tabIndex={0}>
                <span>Suporte</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M13.2807 6.96661L8.00065 11.6666L2.7207 6.96661" stroke="#9A9EA6" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </nav>
          </div>
          
          <div className="nav-right">
            <div className="language-selector" onClick={handleLanguageClick} role="button" tabIndex={0}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10.0013 18.3334C14.6037 18.3334 18.3346 14.6024 18.3346 10C18.3346 5.39765 14.6037 1.66669 10.0013 1.66669C5.39893 1.66669 1.66797 5.39765 1.66797 10C1.66797 14.6024 5.39893 18.3334 10.0013 18.3334Z" stroke="#9A9EA6" strokeWidth="1.2"/>
                <path d="M6.66764 2.5H7.50098C5.87598 7.36667 5.87598 12.6333 7.50098 17.5H6.66764" stroke="#9A9EA6" strokeWidth="1.2"/>
                <path d="M12.501 2.5C14.126 7.36667 14.126 12.6333 12.501 17.5" stroke="#9A9EA6" strokeWidth="1.2"/>
                <path d="M2.50098 13.3333V12.5C7.36764 14.125 12.6343 14.125 17.501 12.5V13.3333" stroke="#9A9EA6" strokeWidth="1.2"/>
                <path d="M2.50098 7.5C7.36764 5.875 12.6343 5.875 17.501 7.5" stroke="#9A9EA6" strokeWidth="1.2"/>
              </svg>
              <span>Português / Brasil</span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M11.9475 6.2533H7.79414H4.05414C3.41414 6.2533 3.09414 7.02663 3.54748 7.47996L7.00081 10.9333C7.55414 11.4866 8.45414 11.4866 9.00748 10.9333L10.3208 9.61996L12.4608 7.47996C12.9075 7.02663 12.5875 6.2533 11.9475 6.2533Z" fill="#9A9EA6"/>
              </svg>
            </div>
            <button className="cta-button" type="button">
              <span>Testar agora</span>
            </button>
          </div>
        </div>
        <div className="header-separator"></div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-tagline">
              <span>👥 • 100,000 Pessoas utilizam o Bíblia Responde</span>
            </div>
            
            <h1 className="hero-title">
              A conexão com <span className="text-primary">Deus</span> no seu dia-a-dia 🙏🏻
            </h1>
            
            <p className="hero-description">
              Faça perguntas e adquira respostas com os ensinamentos bíblicos de forma rápida e eficaz.
            </p>
            
            <div className="hero-ctas">
              <button className="cta-primary" type="button">
                <span>Testar agora</span>
              </button>
              <button className="cta-secondary" type="button">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="play-icon" aria-hidden="true">
                  <circle cx="12" cy="12" r="12" fill="currentColor"/>
                  <path d="M10 8L16 12L10 16V8Z" fill="#FFFFFF"/>
                </svg>
                <span>Ver demonstração</span>
              </button>
            </div>
          </div>
          
          <div className="hero-image">
            <div className="hero-image-bg"></div>
            <img src="/hero.webp" alt="Aplicativo Bíblia Responde em funcionamento" className="hero-main-image" />
            
            <div className="floating-card-1">
              <span>Como fazer devocional?</span>
            </div>
            
            <div className="floating-card-2">
              <div className="card-header">
                <img src="/hero-card.webp" alt="Ilustração sobre devocional" />
              </div>
              <div className="card-content">
                <p>Fazer devocional envolve reservar um momento do seu dia para se conectar com Deus por meio da leitura da Bíblia...</p>
              </div>
            </div>
            
            <div className="floating-icon">
              <div className="biblia-icon">
                <div className="cross-icon"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partner Logos */}
      <section className="partners-section">
        <div className="partners-container">
          <img src="/Exame.svg" alt="Exame" className="partner-logo" />
          <img src="/Infomoney.svg" alt="InfoMoney" className="partner-logo" />
          <div className="partner-featured">
            <img src="/StartSE.svg" alt="StartSe" />
          </div>
          <img src="/Estadao.svg" alt="Estadão" className="partner-logo" />
          <img src="/Extra.svg" alt="Extra" className="partner-logo" />
        </div>
      </section>

      {/* Knowledge Section */}
      <section className="knowledge-section">
        <div className="knowledge-container">
          <div className="knowledge-content">
            <div className="section-label">CONHECIMENTO</div>
            <h2 className="section-title">
              📚 • Tenha acesso aos maiores ensinamentos bíblicos em um só local
            </h2>
            <p className="section-description">
              Você estará conectado a todos os ensinamentos bíblicos que irão facilitar as suas tomadas de decisão mais difíceis do dia-a-dia.
              <br /><br />
              Nós utilizamos a tecnologia para reinventar a forma de como nos conectamos com Deus, obtenha agora suas respostas.
            </p>
          </div>
          <div className="knowledge-image">
            <img src="/mockup.webp" alt="Interface do aplicativo mostrando recursos de conhecimento bíblico" />
          </div>
        </div>
      </section>

      {/* For Whom Section */}
      <section className="for-whom-section">
        <div className="for-whom-container">
          <h2 className="section-title centered">
            📚 • Para quem é o Bíblia Responde?
          </h2>
          <p className="section-subtitle">
            O Bíblia Responde é para você que quer fazer...
          </p>
          
          <div className="cards-grid" ref={cardsRef}>
            <div className="feature-card">
              <img src="/devocional.webp" alt="Devocional Diária" className="card-image" />
              <div className="card-content">
                <h3>Devocional Diária</h3>
                <p>Encontre inspiração diária na Palavra de Deus e fortaleça sua relação com Ele por meio de meditações diárias que o ajudarão a refletir sobre a vida e a sua fé.</p>
              </div>
            </div>
            
            <div className="feature-card">
              <img src="/ensino.webp" alt="Ensino Bíblico" className="card-image" />
              <div className="card-content">
                <h3>2. Ensino Bíblico</h3>
                <p>Aprenda a ensinar a Bíblia de forma eficaz e transmitir suas verdades de maneira clara e impactante, adquirindo ferramentas e técnicas para pregar e ministrar de forma relevante.</p>
              </div>
            </div>
            
            <div className="feature-card">
              <img src="/tematico.webp" alt="Estudos Temáticos" className="card-image" />
              <div className="card-content">
                <h3>3. Estudos Temáticos</h3>
                <p>Explore tópicos específicos da Bíblia e aprofunde seu conhecimento sobre assuntos como salvação, oração, amor, perdão, liderança, entre outros, descobrindo novas perspectivas e insights.</p>
              </div>
            </div>
            
            <div className="feature-card">
              <img src="/perguntas e respostas.webp" alt="Perguntas e Respostas" className="card-image" />
              <div className="card-content">
                <h3>4. Perguntas e Respostas</h3>
                <p>Receba respostas claras e concisas para suas dúvidas mais comuns sobre a Bíblia, teologia, ética e moral cristã, ajudando-o a crescer em sabedoria e discernimento.</p>
              </div>
            </div>
            
            <div className="feature-card">
              <img src="/leitura.webp" alt="Leitura Bíblica" className="card-image" />
              <div className="card-content">
                <h3>5. Leitura Bíblica</h3>
                <p>Desenvolva o hábito de ler a Bíblia diariamente e meditar sobre suas verdades transformadoras, por meio de planos de leitura que o guiarão em sua jornada de fé e crescimento espiritual.</p>
              </div>
            </div>
          </div>
          
          <div className="navigation-controls">
            <button className="nav-btn prev" onClick={handlePrevCards} type="button" aria-label="Anterior">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M12.6555 16.4333C13.263 15.8258 13.263 14.8409 12.6555 14.2334L7.09446 8.67244L12.6555 3.11144C13.263 2.50395 13.263 1.51905 12.6555 0.911559C12.048 0.304066 11.0631 0.304066 10.4556 0.911559L3.79446 7.57244C3.18697 8.17993 3.18697 9.16483 3.79446 9.77232L10.4556 16.4333C11.0631 17.0408 12.048 17.0408 12.6555 16.4333Z" fill="#019FCC"/>
              </svg>
            </button>
            <button className="nav-btn next" onClick={handleNextCards} type="button" aria-label="Próximo">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M7.34446 0.911559C6.73697 1.51905 6.73697 2.50395 7.34446 3.11144L12.9055 8.67244L7.34446 14.2334C6.73697 14.8409 6.73697 15.8258 7.34446 16.4333C7.95195 17.0408 8.93686 17.0408 9.54435 16.4333L16.2055 9.77232C16.813 9.16483 16.813 8.17993 16.2055 7.57244L9.54435 0.911559C8.93686 0.304066 7.95195 0.304066 7.34446 0.911559Z" fill="#019FCC"/>
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Why Use Section */}
      <section className="why-use-section">
        <div className="why-use-container">
          <div className="why-use-content">
            <div className="section-label">FACILIDADE</div>
            <h2 className="section-title">
              Porquê usar o Bíblia Responde?🤔
            </h2>
            
            <div className="benefits-list">
              <div className="benefit-item">
                <div className="benefit-icon">🔎</div>
                <div className="benefit-content">
                  <h3>Respostas precisas e imediatas</h3>
                  <p>Obtenha respostas precisas e confiáveis para suas perguntas bíblicas em questão de segundos.</p>
                </div>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">✏</div>
                <div className="benefit-content">
                  <h3>Acesso a ensinamentos bíblicos</h3>
                  <p>Tenha acesso a uma ampla variedade de ensinamentos bíblicos em um só lugar.</p>
                </div>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">😍</div>
                <div className="benefit-content">
                  <h3>Conexão com Deus</h3>
                  <p>Fortaleça sua conexão com Deus por meio do estudo e compreensão da Escrituras.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="why-use-image">
            <div className="chat-preview">
              <div className="chat-card main-chat">
                <div className="chat-header">
                  </div>
                  <img src="/cruz.webp" alt="Chat Preview" className="chat-image" />
                  <div className="chat-logo-section">
                    <img src="/LOGO.svg" alt="Bíblia Responde Logo" className="chat-logo-img" />
                  </div>
                  <p className="chat-text">
                    A Bíblia ensina que a salvação é possível pela graça divina, através da fé em Jesus Cristo. Isso significa que não podemos merecer ou conquistar a salvação por...
                  </p>
              </div>
              
              <div className="chat-card small-chat">
                <div className="user-info">
                  <img src="/cristian.webp" alt="User Avatar" className="user-avatar" />
                  <span className="user-name">Cristian</span>
                </div>
                <p className="question-text">O que a Bíblia diz sobre a salvação e a graça divina?</p>
                <div className="progress-bar">
                  <div className="progress-fill"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section">
        <div className="pricing-container">
          <div className="pricing-plan free-plan">
            <div className="plan-header">
              <h3>Plano Gratuito</h3>
              <div className="plan-price">
                <span className="price">R$0</span>
              </div>
            </div>
            <p className="plan-description">
              Uma opção gratuita para quem quer testar o Bíblia Responde de forma limitada.
            </p>
            <button className="plan-button">Quero o plano free</button>
            
            <div className="plan-features">
              <h4>Features</h4>
              <div className="feature-list">
                <div className="feature-item included">
                  <svg className="check-icon" width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="9" fill="#00A9CA" stroke="#00A9CA" strokeWidth="2"/>
                    <path d="M7.5 10L9.16667 11.6667L12.5 8.33333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Inteligência Artificial no WhatsApp</span>
                </div>
                <div className="feature-item included">
                  <svg className="check-icon" width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="9" fill="#00A9CA" stroke="#00A9CA" strokeWidth="2"/>
                    <path d="M7.5 10L9.16667 11.6667L12.5 8.33333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Envio e recebimento de áudio</span>
                </div>
                <div className="feature-item included">
                  <svg className="check-icon" width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="9" fill="#00A9CA" stroke="#00A9CA" strokeWidth="2"/>
                    <path d="M7.5 10L9.16667 11.6667L12.5 8.33333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Dicas de uso e 'prompt</span>
                </div>
                <div className="feature-item included">
                  <svg className="check-icon" width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="9" fill="#00A9CA" stroke="#00A9CA" strokeWidth="2"/>
                    <path d="M7.5 10L9.16667 11.6667L12.5 8.33333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>10 mensagens para testar</span>
                </div>
                <div className="feature-item excluded">
                  <svg className="x-icon" width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="9" fill="#FF4747"/>
                    <path d="M12.5 7.5L7.5 12.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7.5 7.5L12.5 12.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Mensagens ilimitadas</span>
                </div>
                <div className="feature-item excluded">
                  <svg className="x-icon" width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="9" fill="#FF4747"/>
                    <path d="M12.5 7.5L7.5 12.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7.5 7.5L12.5 12.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Prioridade para novas funcionalidades</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="pricing-plan pro-plan">
            <div className="plan-badge">Recomendado</div>
            <div className="plan-header">
              <h3>Plano PRO</h3>
              <div className="plan-price">
                <span className="price">R$30</span>
                <span className="period">/mensal</span>
              </div>
            </div>
            <p className="plan-description">
              A escolha certa para quem busca uma conexão mais profunda com a Palavra.
            </p>
            <button className="plan-button">Quero o Plano PRO</button>
            
            <div className="plan-features">
              <h4>Features</h4>
              <div className="feature-list">
                <div className="feature-item included">
                  <svg className="check-icon" width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="9" fill="#00A9CA" stroke="#00A9CA" strokeWidth="2"/>
                    <path d="M7.5 10L9.16667 11.6667L12.5 8.33333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Inteligência Artificial no WhatsApp</span>
                </div>
                <div className="feature-item included">
                  <svg className="check-icon" width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="9" fill="#00A9CA" stroke="#00A9CA" strokeWidth="2"/>
                    <path d="M7.5 10L9.16667 11.6667L12.5 8.33333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Envio e recebimento de áudio</span>
                </div>
                <div className="feature-item included">
                  <svg className="check-icon" width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="9" fill="#00A9CA" stroke="#00A9CA" strokeWidth="2"/>
                    <path d="M7.5 10L9.16667 11.6667L12.5 8.33333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Dicas de uso e 'prompt</span>
                </div>
                <div className="feature-item included">
                  <svg className="check-icon" width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="9" fill="#00A9CA" stroke="#00A9CA" strokeWidth="2"/>
                    <path d="M7.5 10L9.16667 11.6667L12.5 8.33333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Mensagens ilimitadas</span>
                </div>
                <div className="feature-item included">
                  <svg className="check-icon" width="20" height="20" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="9" fill="#00A9CA" stroke="#00A9CA" strokeWidth="2"/>
                    <path d="M7.5 10L9.16667 11.6667L12.5 8.33333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Prioridade para novas funcionalidades</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="testimonials-container">
          <div className="section-label">DEPOIMENTOS</div>
          <h2 className="section-title">
            💬 • O que dizem sobre o Bíblia Responde
          </h2>
          <p className="section-subtitle">
            Você está curioso sobre as avaliações dos usuários que usam o Bíblia Responde para adquirirem mais conhecimento e se conectar com Deus? Veja abaixo
          </p>
          
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <img src="/dp1.webp" alt="João Fernando" className="testimonial-avatar" />
              <div className="testimonial-content">
                <p className="testimonial-text">
                  "Eu sempre tive muitas dúvidas sobre as Escrituras, mas o Bíblia Responde me ajudou a encontrar respostas precisas e confiáveis para minhas perguntas. É uma ferramenta indispensável para quem quer se aprofundar no estudo bíblico."
                </p>
                <div className="rating">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} size={22} color="#E77C40" />
                  ))}
                </div>
                <div className="testimonial-author">João Fernando</div>
                <div className="testimonial-age">35 anos</div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <img src="/dp2.webp" alt="Maria Elena" className="testimonial-avatar" />
              <div className="testimonial-content">
                <p className="testimonial-text">
                  "Eu amo usar o Bíblia Responde para me ajudar a entender melhor a Palavra de Deus. É muito fácil de usar e as respostas são sempre relevantes e úteis para minha vida diária."
                </p>
                <div className="rating">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} size={22} color="#E77C40" />
                  ))}
                </div>
                <div className="testimonial-author">Maria Elena</div>
                <div className="testimonial-age">58 anos</div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <img src="/dp3.webp" alt="Cristiano Constantino" className="testimonial-avatar" />
              <div className="testimonial-content">
                <p className="testimonial-text">
                  "Eu sou pastor há muitos anos e sempre busco formas de aprimorar meu conhecimento bíblico. O Bíblia Responde tem sido uma ferramenta essencial para mim e minha congregação, fornecendo respostas precisas e confiáveis para nossas perguntas mais difíceis."
                </p>
                <div className="rating">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} size={22} color="#E77C40" />
                  ))}
                </div>
                <div className="testimonial-author">Cristiano Constantino</div>
                <div className="testimonial-age">52 anos</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="faq-container">
          <div className="section-label">FAQ</div>
          <h2 className="section-title">
            🤔• Perguntas Frequentes
          </h2>
          
          <div className="faq-list">
            <div className="faq-item">
              <button 
                className="faq-question"
                onClick={() => toggleFaq(0)}
              >
                <span>Como funciona o Bíblia Responde?</span>
                 <div className={`faq-icon ${expandedFaq === 0 ? 'expanded' : ''}`}>
                  <FaChevronRight 
                    size={12} 
                    color={expandedFaq === 0 ? "white" : "#737373"}
                    style={{ transform: expandedFaq === 0 ? 'rotate(90deg)' : 'rotate(0deg)' }}
                  />
                </div>
              </button>
              {expandedFaq === 0 && (
                <div className="faq-answer">
                  <p>Você envia suas perguntas e recebe respostas baseadas nos ensinamentos bíblicos. O sistema utiliza tecnologia para buscar, organizar e apresentar os textos de forma clara e contextualizada.</p>
                </div>
              )}
            </div>
            
            <div className="faq-item">
              <button 
                className="faq-question"
                onClick={() => toggleFaq(1)}
              >
                <span>Quais tipos de perguntas posso fazer no Bíblia Responde?</span>
                 <div className={`faq-icon ${expandedFaq === 1 ? 'expanded' : ''}`}>
                  <FaChevronRight 
                    size={12} 
                    color={expandedFaq === 1 ? "white" : "#737373"}
                    style={{ transform: expandedFaq === 1 ? 'rotate(90deg)' : 'rotate(0deg)' }}
                  />
                </div>
              </button>
              {expandedFaq === 1 && (
                <div className="faq-answer">
                  <p>Você pode fazer perguntas sobre qualquer tema relacionado à Bíblia, como interpretação de versículos, doutrina, história, cultura e muito mais</p>
                </div>
              )}
            </div>
            
            <div className="faq-item">
              <button 
                className="faq-question"
                onClick={() => toggleFaq(2)}
              >
                <span>O Bíblia Responde é confiável?</span>
                 <div className={`faq-icon ${expandedFaq === 2 ? 'expanded' : ''}`}>
                  <FaChevronRight 
                    size={12} 
                    color={expandedFaq === 2 ? "white" : "#737373"}
                    style={{ transform: expandedFaq === 2 ? 'rotate(90deg)' : 'rotate(0deg)' }}
                  />
                </div>
              </button>
              {expandedFaq === 2 && (
                <div className="faq-answer">
                  <p>Sim. As respostas são produzidas com base nas Escrituras e revisadas para manter coerência, contexto e clareza, evitando interpretações isoladas ou desconectadas do texto bíblico.</p>
                </div>
              )}
            </div>
            
            <div className="faq-item">
              <button 
                className="faq-question"
                onClick={() => toggleFaq(3)}
              >
                <span>O Bíblia Responde oferece versões da Bíblia em outros idiomas?</span>
                 <div className={`faq-icon ${expandedFaq === 3 ? 'expanded' : ''}`}>
                  <FaChevronRight 
                    size={12} 
                    color={expandedFaq === 3 ? "white" : "#737373"}
                    style={{ transform: expandedFaq === 3 ? 'rotate(90deg)' : 'rotate(0deg)' }}
                  />
                </div>
              </button>
              {expandedFaq === 3 && (
                <div className="faq-answer">
                  <p>Oferecemos conteúdos e referências em português, e estamos adicionando gradualmente suporte a outras traduções e idiomas, conforme a disponibilidade e direitos de uso.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BibliaRespondeLanding;
